import { apolloProvider } from '@/modules/GraphQL';
import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { CUSTOMER_FEEDACK_LOG_VIEW, CUSTOMER_FEEDACK_LOG_VIEW_MSB } from '@/graphql/mutations/customerFeedback';

import logger from '@/modules/Logger';

export const LogCustomerFeedbackViewService = {
  // Method to fetch PDF from new GraphQL endpoint
  msb: async (studentBookId) => {
    logger.debug(`[CFE][LogCustomerFeedbackView] Log customer feedback view from MSB GraphQL endpoint`, {
      operation: 'cfe:log-customer-feedback-view'
    });

    const client = myStageApolloProvider.defaultClient;
    const { data } = await client.mutate({
      mutation: CUSTOMER_FEEDACK_LOG_VIEW_MSB,
      fetchPolicy: 'no-cache',
      variables: {
        student_book_id: studentBookId      
      }
    });

    if (data?.logCustomerFeedbackView) {
      return data.logCustomerFeedbackView;
    } else {
      logger.error(`[CFE][LogCustomerFeedbackView] Empty result from MSB GraphQL API`, {
        operation: 'cfe:log-customer-feedback-view',
        student_book_id: studentBookId,
      });
    }
  },

  mbti: async (studentBookId) => {
    logger.debug(`[CFE][LogCustomerFeedbackView] Log customer feedback view from MBTI GraphQL endpoint`, {
      operation: 'cfe:log-customer-feedback-view'
    });

    const client = apolloProvider.defaultClient;
    const { data } = await client.mutate({
      mutation: CUSTOMER_FEEDACK_LOG_VIEW,
      fetchPolicy: 'no-cache',
      variables: {
        student_book_id: studentBookId      
      }
    });

    if (data?.customer_feedback_log_view) {
      return data.customer_feedback_log_view;
    } else {
      logger.error(`[CFE][LogCustomerFeedbackView] Empty result from MBTI GraphQL API`, {
        operation: 'cfe:log-customer-feedback-view',
        student_book_id: studentBookId,
      });
    }
  }
};

// Route legacy endpoint to MBTI, because this API does not have FuelPHP version
LogCustomerFeedbackViewService.legacy = LogCustomerFeedbackViewService.mbti;
